module.exports = __webpack_public_path__ + "img/background1.295e83ae.png";